import React from 'react'
import ResultsList from './resultCard'
import ResultsListDesk from './resultsListDesk'
import InfoCard from './infoCard'
import useIsMobile from '../hooks/useIsMobile'
import { is } from 'date-fns/locale'

const LabResultsSection = ({
	loading,
	error,
	paginatedResults,
	hasActiveFilters,
	isCarousel = true,
    isHome = false
}) => {
	const isMobile = useIsMobile()
	if (loading) return <p>Cargando resultados...</p>
	if ((error || !paginatedResults || paginatedResults.length === 0) && isHome) {
		return (
			<InfoCard
				title="No se encontraron resultados"
				subtitle="Todavía no tenés resultados de laboratorio disponibles."
			/>
		)
	}
	return (
		<>
			<ResultsList
				isSearch={hasActiveFilters}
				results={paginatedResults}
				isCarousel={isCarousel}
				fields={[
					{ label: 'Fecha de informe', key: 'fecha' },
					{ label: 'Número de orden', key: 'orden' },
					{ label: 'Clínica', key: 'clinica' },
					{ key: 'informe' }
				]}
				style={{ display: isMobile ? 'block' : 'none' }}
			/>
			<ResultsListDesk
				hasActiveFilters={hasActiveFilters}
				results={paginatedResults}
				style={{ display: isMobile ? 'none' : 'block' }}
			/>
		</>
	)
}

export default React.memo(LabResultsSection)
